module.exports = __webpack_public_path__ + "img/img9.b20acfbd.png";